import React, { Component } from 'react';

import SecurityScreening from './SecurityScreening';
import { SCREENING_METHOD_CODES, SEARCH_OPTIONS_SCHEMA } from '../../../utils/Analytics';
import ResponseError from '../../../models/ResponseError';
import { receiveError } from '../../../store/actions/notificationAction';
import { connect } from 'react-redux';
import ApiResponse from '../../../models/ApiResponse';
import AirlineType from '../../../models/AirlineType';
import moment, { Moment } from 'moment';
import analyticsRemote from '../../../api/analyticsRemote';
import { AnalyDetail, CustomerWaitSearchOption, SecScrnData, UnScreenedData, filterOptions, UnScreenedFilter } from '../../../models/Analytics';
import { ExportToCsv } from 'export-to-csv';
import Screening from '../../../models/Screening';
import ScreeningResponse from '../../../models/ScreeningResponse';
import { ActiveElement, ChartEvent } from 'chart.js';

interface SecurityScreeningContainerProps {
  receiveError: Function;
  airlines: AirlineType[];
  startDate: Moment;
  endDate: Moment;
  handleChangeDate: (dateType: string, event: any) => void;
};

interface SecurityScreeningContainerState {
  searchOptions: CustomerWaitSearchOption;
  filterOptions: filterOptions;
  progress: boolean;
  data: SecScrnData[];
  exemptions: ScreeningResponse[];
  orders: SecScrnData[];
  screeners: AnalyDetail[];
  airlines: AirlineType[];
  measure: string;
  measures: any[string];
  scrMeasures: string[];
  scrExemptions: string[];
  alarms: number[];
  methods: any[string];
  alarmCount: number;
  shipments: UnScreenedData[];
  shipmentFilter: UnScreenedFilter;
  shipmentData: SecScrnData[];
  exceedHours: number;
};
class SecurityScreeningContainer extends Component<SecurityScreeningContainerProps, SecurityScreeningContainerState> {
  state = {
    filterOptions: {
      carriers: true,
      report: true,
      screener: true,
      time: true,
    },
    progress: false,
    searchOptions: { ...SEARCH_OPTIONS_SCHEMA, startDate: this.props.startDate, endDate: this.props.endDate },
    data: [],
    exemptions: [],
    orders: [],
    screeners: [],
    airlines: this.props.airlines,
    scn: [],
    measure: 'Screened',
    scrMeasures: [],
    scrExemptions: [],
    measures: [],
    alarms: [0, 0, 0],
    methods: [],
    alarmCount: 0,
    shipments: [],
    shipmentFilter: {
      transit: false,
      interline: false,
      ccsf: false,
      its: false
    },
    shipmentData: [],
    exceedHours: 0,
  }

  componentWillReceiveProps(nextProps: SecurityScreeningContainerProps) {
    let searchOptions = this.state.searchOptions;
    if (nextProps.startDate !== this.state.searchOptions.startDate || nextProps.endDate !== this.state.searchOptions.endDate) {
      searchOptions.startDate = nextProps.startDate;
      searchOptions.endDate = nextProps.endDate;
      this.setState({ searchOptions }, () => {
        this.loadOdersData();
      });
    }
    if (nextProps.airlines != this.state.airlines) {
      let carr = nextProps.airlines.map(a => a.iata_code);
      this.setState({ airlines: nextProps.airlines, searchOptions: { ...this.state.searchOptions, carr: carr.toString() } }, () => {
        this.getExemptions();
        this.filterOdersData();
      });
    }
  }

  componentDidMount() {
    if (this.state.airlines.length > 0) {
      let carr = this.state.airlines.map((a: AirlineType) => a.iata_code);
      this.setState({ searchOptions: { ...this.state.searchOptions, carr: carr.toString() } }, () => {
        this.getExemptions();
        this.filterOdersData();
      });
    }
    this.loadExemptions();
    this.loadOdersData();
  }

  loadExemptions = (): void => {
    analyticsRemote.getScreeningExemptions().then((resp: ApiResponse<Array<ScreeningResponse>>) => {
      const exemptions: Array<ScreeningResponse> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      if (exemptions) {
        this.setState({ exemptions }, () => {
          this.getExemptions();
        });
      }
      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  loadOdersData = (): void => {
    this.setState({ progress: true }, () => {
      let searchOptions = this.state.searchOptions;
      let startDate: string = searchOptions.startDate.format('YYYYMMDD');
      let endDate: string = searchOptions.endDate.format('YYYYMMDD');
      analyticsRemote.getScreeningData(startDate, endDate, this.state.exceedHours).then((resp: ApiResponse<Array<SecScrnData>>) => {
        const data: Array<SecScrnData> | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        if (data) {
          this.setState({ data, searchOptions: { ...this.state.searchOptions } }, () => {
            this.filterOdersData();
          });
        }
        if (error) {
          this.props.receiveError(error);
        };
        this.setState({ progress: false });
      });
    });
    
  }

  handleExceedHoursChange = (value: any): void => {
    // Convert empty string or null to undefined
    const parsedValue = value === '' || value === null ? undefined : value;
    
    this.setState({ exceedHours: parsedValue }, () => {
      this.loadOdersData();
    });
  }

  filterOdersData = (): void => {
    let orders = this.state.airlines.length > 0 && this.state.searchOptions.carr != '' ? this.state.data : [];
    // Handled Carriers
    if (this.state.searchOptions.carr && this.state.searchOptions.carr != '') {
      orders = orders.filter((o: SecScrnData) => {
        if (o.awb && o.awb.airline_code) {
          if (o.awb.airline_code && this.state.searchOptions.carr.includes(o.awb.airline_code)) {
            return o;
          }
        }
      });
    }

    if (this.state.searchOptions.startTime && this.state.searchOptions.endTime) {
      orders = orders.filter((o: SecScrnData) => {
        let time = moment(o.pickup_time ? o.pickup_time : '0000', 'HHmm')
        if (time.isSameOrAfter(this.state.searchOptions.startTime) && time.isSameOrBefore(this.state.searchOptions.endTime)) {
          return o;
        }
      });
    }
    this.setState({ orders }, () => {
      this.getData();
    });
  }

  filterShipmentData = (): void => {
    let shipments: UnScreenedData[] = [];
    this.state.shipmentData.map((s: SecScrnData) => {
      let exclued = false;
      if (this.state.shipmentFilter.transit && s.forwarder.type == 'rfs') {
        exclued = true;
      }
      if (this.state.shipmentFilter.interline && s.forwarder.type == 'interline') {
        exclued = true;
      }
      if (this.state.shipmentFilter.ccsf && s.ccsf_pre_screened) {
        exclued = true;
      }
      if (this.state.shipmentFilter.its && s.its) {
        exclued = true;
      }
      if (!exclued) {
        shipments.push({
          awb: s.awb.code + '-' + s.awb.number,
          org: s.awb.origin,
          dest: s.awb.destination,
          pcs: s.pieces,
          wgt: s.weight,
          out_flt: s.awb.export_metadata.firstFlightNumber + '/' + moment(s.awb.export_metadata.firstFlightDate, 'YYYYMMDD').format('DDMMM').toUpperCase(),
          fwd: s.forwarder.name,
          rcvd_by: s.gha && s.gha.first_name ? s.gha.first_name + ' ' + s.gha.last_name : '',
          rcvd_time: moment(s.pickup_date, 'YYYYMMDD').format('DD MMM YY').toUpperCase() + ' ' + (s.pickup_time ? s.pickup_time.replace(/([\d]{2})([\d]{2})/, '$1:$2') : '00:00'),
        });
      }
    });
    this.setState({ shipments });
  }

  getExemptions = () => {
    if (this.state.airlines.length > 0 && this.state.exemptions.length > 0) {
      const airline: number[] = []
      this.state.airlines.map((a: AirlineType) => {
        if (this.state.searchOptions.carr && this.state.searchOptions.carr != '') {
          if (this.state.searchOptions.carr.includes(a.iata_code)) {
            airline.push(a.id);
          }
        }
      });
      let scrExemptions: string[] = []
      let scrMeasures: string[] = []
      this.state.exemptions.map((e: ScreeningResponse) => {
        if (airline.includes(e.airline_id)) {
          e.measure && e.measure.measures.map((d: string) => {
            if (!scrMeasures.includes(d))
              scrMeasures.push(d);
          });
        }
      });
      this.state.exemptions.map((e: ScreeningResponse) => {
        if (airline.includes(e.airline_id)) {
          let data: string[] = [];
          switch (this.state.measure) {
            case 'Screened':
              data = e.exemptions.screened;
              break;
            case 'Exemption':
              data = e.exemptions.exemptions || [];
              break;
            case 'Alternative Screening':
              data = e.exemptions.alternative_screening || [];
              break;
            case 'Exemption Domestic Cargo':
              data = e.exemptions.exemptions_domestic || [];
              break;
            case 'Exemption International Cargo':
              data = e.exemptions.exemptions_international || [];
              break;
            case 'No Chain of Custody':
              data = e.exemptions.chain_of_custody || [];
              break;
            case 'Other':
              data = e.exemptions.other || [];
              break;
            default:
              break;
          }
          data && data.map((d: string) => {
            if (!scrExemptions.includes(d))
              scrExemptions.push(d);
          });
        }
      });
      this.setState({ scrMeasures, scrExemptions });
    }
  };

  getData = () => {
    let screeners: AnalyDetail[] = [];
    let measures: any[string] = [];
    let alarms = [0, 0, 0, 0];
    let alarmCount = 0;
    let methods: any[string] = [];
    let shipmentData: SecScrnData[] = [];
    this.state.orders.map((o: SecScrnData) => {
      if (o.screen.length > 0) {
        o.screen.map((s: Screening) => {
          if (this.state.searchOptions.scr_name == '' || (this.state.searchOptions.scr_name != '' && s.screened_by == this.state.searchOptions.scr_name)) {
            if (s.measure_applied) {
              if (measures[s.measure_applied]) {
                measures[s.measure_applied] += this.state.searchOptions.report == 'pcs' ? s.pieces : (this.state.searchOptions.report == 'wgt' ? o.weight : 1);
              } else {
                measures[s.measure_applied] = this.state.searchOptions.report == 'pcs' ? s.pieces : (this.state.searchOptions.report == 'wgt' ? o.weight : 1);
              }
            }
            if (s.alarm) {
              alarmCount++;
              if (s.alarm_resolution) {
                switch (s.alarm_resolution) {
                  case 'Inner ETD':
                    alarms[0] += this.state.searchOptions.report == 'pcs' ? s.pieces : (this.state.searchOptions.report == 'wgt' ? o.weight : 1);
                    break;
                  case 'Physical Search':
                    alarms[1] += this.state.searchOptions.report == 'pcs' ? s.pieces : (this.state.searchOptions.report == 'wgt' ? o.weight : 1);
                    break;
                  case 'Xray':
                    alarms[2] += this.state.searchOptions.report == 'pcs' ? s.pieces : (this.state.searchOptions.report == 'wgt' ? o.weight : 1);
                    break;
                  default:
                    alarms[3] += this.state.searchOptions.report == 'pcs' ? s.pieces : (this.state.searchOptions.report == 'wgt' ? o.weight : 1);
                    break;
                }
              }
            }
            if (s.screening_details) {
              if (methods[s.measure_applied + s.screening_details]) {
                methods[s.measure_applied + s.screening_details] += this.state.searchOptions.report == 'pcs' ? s.pieces : (this.state.searchOptions.report == 'wgt' ? o.weight : 1);
              } else {
                methods[s.measure_applied + s.screening_details] = this.state.searchOptions.report == 'pcs' ? s.pieces : (this.state.searchOptions.report == 'wgt' ? o.weight : 1);
              }
            }
            const exists = screeners.findIndex(((scr: AnalyDetail) => scr.name === s.screened_by))
            if (exists >= 0) {
              screeners[exists].pcs += s.pieces;
              screeners[exists].awbs += 1;
              screeners[exists].wgt += o.weight;
            } else {
              screeners.push({ name: s.screened_by, pcs: s.pieces, awbs: 1, wgt: o.weight });
            }
          }
        })
      } else {
        shipmentData.push(o);
      }
    })
    let key: string = this.state.searchOptions.report;
    screeners.sort(function (a: any, b: any) {
      return parseFloat(b[key]) - parseFloat(a[key]);
    });
    this.setState({ screeners, measures, methods, alarms, alarmCount, shipmentData }, () => {
      this.filterShipmentData();
    });
  }
  handleChangeCarriers = (type: string, value: boolean): void => {
    const searchOptions = { ...this.state.searchOptions };
    let carr = searchOptions.carr.split(',');
    if (type == 'GLOABL' && !value) {
      carr = [];
      searchOptions.carrCheck = value;
    } else if (type == 'GLOABL' && value) {
      carr = this.state.airlines.map(a => a.iata_code);
      searchOptions.carrCheck = value;
    } else {
      if (value) {
        carr.push(type);
      } else {
        var index = carr.indexOf(type);
        if (index !== -1) {
          carr.splice(index, 1);
        }
      }
    }
    searchOptions.carr = carr.toString();
    this.setState({ searchOptions: searchOptions }, () => {
      this.getExemptions();
      this.filterOdersData();
    });
  }

  handleChangeOption = (type: string, event: any): void => {
    let searchOptions = { ...this.state.searchOptions, [type]: event };
    this.setState({ searchOptions: searchOptions }, () => {
      if (type == 'report') {
        this.getData();
      }
      if (type == 'scr_name') {
        this.filterOdersData();
      }
      if (type == 'measure') {
        this.getExemptions();
      }
    });
  }

  handleChartClick = (event: ChartEvent, elements: ActiveElement[]): void => {
    let measure = elements && elements[0] ? this.state.scrMeasures[elements[0].index] : this.state.scrMeasures[0]
    this.setState({ measure }, () => {
      this.getExemptions();
    })
  };


  handleChangeShipmentFilter = (type: string, event: boolean): void => {
    let shipmentFilter = { ...this.state.shipmentFilter, [type]: event };
    this.setState({ shipmentFilter }, () => {
      this.filterShipmentData();
    });
  }

  handleExport = (type: string): void => {
    let headers: string[] = [];
    let data: any[] = [];
    let filename = '';
    if (type == 'measures') {
      headers = ['Security Measures Applied', 'PCS', 'AWBS', 'WGT'];
      const scrMeasures: string[] = this.state.scrMeasures
      data = scrMeasures.map((m: string) => {
        return {
          measure: m,
          pcs: 0,
          awbs: 0,
          wgt: 0
        }
      })
      this.state.orders.map((o: SecScrnData) => {
        if (o.screen.length > 0) {
          o.screen.map((s: Screening) => {
            if (this.state.searchOptions.scr_name == '' || (this.state.searchOptions.scr_name != '' && s.screened_by == this.state.searchOptions.scr_name)) {
              if (s.measure_applied) {
                let index: number = scrMeasures.indexOf(s.measure_applied);
                if (data[index]) {
                  data[index].pcs += s.pieces;
                  data[index].wgt += o.weight;
                  data[index].awbs++;
                }
              }
            }
          });
        }
      });
      filename = 'Security Measures Applied';
    }
    if (type == 'methods') {
      headers = [this.state.measure, 'PCS', 'AWBS', 'WGT'];
      const scrExemptions: string[] = this.state.scrExemptions
      data = scrExemptions.map((m: string) => {
        return {
          method: SCREENING_METHOD_CODES[m] ? SCREENING_METHOD_CODES[m].code : m,
          pcs: 0,
          awbs: 0,
          wgt: 0
        }
      })
      this.state.orders.map((o: SecScrnData) => {
        if (o.screen.length > 0) {
          o.screen.map((s: Screening) => {
            if (this.state.searchOptions.scr_name == '' || (this.state.searchOptions.scr_name != '' && s.screened_by == this.state.searchOptions.scr_name)) {
              if (s.screening_details && s.measure_applied == this.state.measure) {
                let index: number = scrExemptions.indexOf(s.screening_details);
                if (data[index]) {
                  data[index].pcs += s.pieces;
                  data[index].wgt += o.weight;
                  data[index].awbs++;
                }
              }
            }
          });
        }
      });
      filename = this.state.measure;
    }
    if (type == 'alarms') {
      headers = ['Screening Alarms', 'PCS', 'AWBS', 'WGT'];
      data = [
        {
          name: 'XRY',
          pcs: 0,
          awbs: 0,
          wgt: 0
        },
        {
          name: 'ETD',
          pcs: 0,
          awbs: 0,
          wgt: 0
        },
        {
          name: 'PHY',
          pcs: 0,
          awbs: 0,
          wgt: 0
        },
        {
          name: 'EDO',
          pcs: 0,
          awbs: 0,
          wgt: 0
        }
      ];
      this.state.orders.map((o: SecScrnData) => {
        if (o.screen.length > 0) {
          o.screen.map((s: Screening) => {
            if (this.state.searchOptions.scr_name == '' || (this.state.searchOptions.scr_name != '' && s.screened_by == this.state.searchOptions.scr_name)) {
              if (s.alarm) {
                if (s.alarm_resolution) {
                  switch (s.alarm_resolution) {
                    case 'Inner ETD':
                      data[0].pcs += s.pieces;
                      data[0].wgt += o.weight;
                      data[0].awbs++;
                      break;
                    case 'Physical Search':
                      data[1].pcs += s.pieces;
                      data[1].wgt += o.weight;
                      data[1].awbs++;
                      break;
                    case 'Xray':
                      data[2].pcs += s.pieces;
                      data[2].wgt += o.weight;
                      data[2].awbs++;
                      break;
                    default:
                      data[3].pcs += s.pieces;
                      data[3].wgt += o.weight;
                      data[3].awbs++;
                      break;
                  }
                }
              }
            }
          });
        }
      });
      filename = 'Screening Alarms';
    }
    if (type == 'screeners') {
      headers = ['Screeners', 'PCS', 'AWBS', 'WGT'];
      data = this.state.screeners;
      filename = 'Top Screeners';
    }
    if (type == 'shipments') {
      headers = ['AWBS', 'ORG', 'DES', 'PCS', 'WGT', 'OUT FLT', 'FWD/INT/RFS', 'RCVD BY', 'RCVD TIME'];
      data = this.state.shipments.map((s: UnScreenedData) => {
        return {
          awb: s.awb,
          org: s.org,
          dest: s.dest,
          pcs: s.pcs,
          wgt: s.wgt,
          out_flt: s.out_flt,
          fwd: s.fwd,
          rcvd_by: s.rcvd_by,
          rcvd_time: s.rcvd_time,
        }
      });
      filename = 'Unscreened Shipments';
    }
    let options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      filename: filename,
      useTextFile: false,
      useBom: false,
      useKeysAsHeaders: false,
      headers: headers
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(data);
  }

  handleChangeTime = (type: string, date: Moment): void => {
    let searchOptions = { ...this.state.searchOptions, [type]: date }
    this.setState({ searchOptions: searchOptions }, () => {
      this.filterOdersData();
    });
  }

  render() {
    return (
      <SecurityScreening
        progress={this.state.progress}
        startDate={this.state.searchOptions.startDate}
        endDate={this.state.searchOptions.endDate}
        startTime={this.state.searchOptions.startTime}
        endTime={this.state.searchOptions.endTime}
        carrCheck={this.state.searchOptions.carrCheck}
        carr={this.state.searchOptions.carr}
        filterOptions={this.state.filterOptions}
        airlines={this.state.airlines}
        scrMeasures={this.state.scrMeasures}
        scrExemptions={this.state.scrExemptions}
        scr_name={this.state.searchOptions.scr_name}
        screeners={this.state.screeners}
        measure={this.state.measure}
        measures={this.state.measures}
        methods={this.state.methods}
        alarms={this.state.alarms}
        alarmCount={this.state.alarmCount}
        report={this.state.searchOptions.report}
        shipments={this.state.shipments}
        shipmentFilter={this.state.shipmentFilter}
        handleChangeCarriers={this.handleChangeCarriers}
        handleChangeDate={this.props.handleChangeDate}
        handleChangeTime={this.handleChangeTime}
        handleChangeOption={this.handleChangeOption}
        handleChartClick={this.handleChartClick}
        handleChangeShipmentFilter={this.handleChangeShipmentFilter}
        handleExport={this.handleExport}
        handleExceedHoursChange={this.handleExceedHoursChange}
        exceedHours={this.state.exceedHours} 
      />
    )
  };
}


const mapStateToProps = (state: any) => {
  return {
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SecurityScreeningContainer);